import axios from "axios";
const api = axios.create({
  baseURL: process.env.REACT_APP_HOST ?? "http://localhost:3100",
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  // eslint-disable-next-line func-names
  async function (error) {
    if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED' || axios.isCancel(error)) {
      return Promise.reject(error);
    }

    if (error.response) {
      if (
        error.response.status === 401 &&
        window.location.pathname !== "/login"
      ) {
        console.log("[API Interceptor] 401 error detected, redirecting to login", {
          url: error.config?.url,
          pathname: window.location.pathname
        });
        localStorage.removeItem("@mmeventos:access_token");
        localStorage.removeItem("@mmeventos:renew_token");
        localStorage.removeItem("@mmeventos:user");

        window.location.href = "/login";
      }
    } else if (error?.response?.data?.errors) {
      // eslint-disable-next-line no-alert
      alert(`Ops ocorreu um erro: ${error?.response?.data?.errors}`);
    } else {
      // eslint-disable-next-line no-alert
      alert(`Ops ocorreu um erro: ${error?.message}`);
    }
    return Promise.reject(error);
  }
);

export { api };
